export default __webpack_public_path__ + "static/media/email-floating.3d923842.svg";